/**
 * Datas-calendário (YYYY-MM-DD) no fuso de quem está usando o sistema.
 *
 * ⚠️ POR QUE ESTE ARQUIVO EXISTE
 *
 * `new Date().toISOString().slice(0, 10)` devolve a data em UTC. No Brasil
 * (UTC-3), das 21h às 23h59 o UTC já está no dia seguinte — então registrar um
 * pagamento às 21h30 do dia 9 gravava "10". A auditoria de 09/09/2026 achou
 * isso em 24 lugares do projeto, incluindo o `paid_at` que vai impresso nos
 * recibos e o vencimento das assinaturas dos clientes.
 *
 * Regra prática:
 *   - instante AGORA → tem que passar por aqui (`hojeISO`)
 *   - Timestamp do Firestore → `dataLocalISO(ts.toDate())`
 *   - `new Date(ano, mês, dia)` (meia-noite local) → já sai certo no Brasil,
 *     não precisa deste helper
 *   - serial de planilha do Excel → é construído em UTC de propósito;
 *     `toISOString()` ali é o CORRETO, não "consertar"
 */

/** Uma data qualquer → 'YYYY-MM-DD' no fuso local (não em UTC). */
export function dataLocalISO(d: Date): string {
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000)
    .toISOString()
    .slice(0, 10)
}

/** Hoje → 'YYYY-MM-DD' no fuso local. */
export function hojeISO(): string {
  return dataLocalISO(new Date())
}

/** Hoje + N dias → 'YYYY-MM-DD' no fuso local (N negativo anda pra trás). */
export function hojeMaisDiasISO(dias: number): string {
  const d = new Date()
  d.setDate(d.getDate() + dias)
  return dataLocalISO(d)
}
